function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "38",
  height: "42"
}, props), /*#__PURE__*/React.createElement("path", {
  id: "Path_1606",
  "data-name": "Path 1606",
  d: "M37 43H5a3 3 0 01-3-3V4a3 3 0 013-3h32a3 3 0 013 3v36a3 3 0 01-3 3zM5 3a1 1 0 00-1 1v36a1 1 0 001 1h32a1 1 0 001-1V4a1 1 0 00-1-1zm31 36H6V5h30zM8 37h26V7H8zm22-4H12v-6h18zm-16-2h14v-2H14zm16-6H12v-6h18zm-16-2h14v-2H14zm16-6H12v-6h18zm-16-2h14v-2H14z",
  transform: "translate(-2 -1)",
  fill: "#009bdb"
})));